<template>
  <div class="chat-body" ref="message-list">
    <div class="more" v-if="!isCompleted">
      <div @click="$store.dispatch('chat/getMessageList', currentConversation.conversationID)">
        查看更多
      </div>
    </div>
    <div class="no-more" v-else>没有更多了</div>
    <div>
      <message-item v-for="message in currentMessageList" :key="message.ID"  :message="message" />
    </div>
    <div v-show="isShowScrollButtomTips" class="newMessageTips" @click="scrollMessageListToButtom">回到最新位置</div>
  </div>
</template>

<script>
import MessageItem from './message-item.vue'
import { mapState } from 'vuex'

export default {
  name: 'ChatBody',
  props: {},
  computed: {
    ...mapState('chat', ['currentConversation', 'currentMessageList', 'isCompleted'])
  },
  components: {
    MessageItem
  },
  data () {
    this.flag = true
    return {
      isShowScrollButtomTips: false,
      preScrollHeight: 0
    }
  },
  created () {},
  mounted () {
    this.$bus.$on('image-loaded', this.onImageLoaded)
    this.$bus.$on('scroll-bottom', this.scrollMessageListToButtom)
  },
  watch: {
    currentMessageList (newVal) {
      if (newVal.length && this.flag) {
        this.flag = false
        this.scrollMessageListToButtom()
      }
    }
  },
  methods: {
    // 直接滚到底部
    scrollMessageListToButtom () {
      this.$nextTick(() => {
        const messageListNode = this.$refs['message-list']
        if (!messageListNode) {
          return
        }
        messageListNode.scrollTop = messageListNode.scrollHeight
        this.preScrollHeight = messageListNode.scrollHeight
        this.isShowScrollButtomTips = false
      })
    },
    // 如果滚到底部就保持在底部，否则提示是否要滚到底部
    keepMessageListOnButtom () {
      let messageListNode = this.$refs['message-list']
      if (!messageListNode) {
        return
      }
      // 距离底部20px内强制滚到底部,否则提示有新消息
      if (this.preScrollHeight - messageListNode.clientHeight - messageListNode.scrollTop < 20) {
        this.$nextTick(() => {
          messageListNode.scrollTop = messageListNode.scrollHeight
        })
        this.isShowScrollButtomTips = false
      } else {
        this.isShowScrollButtomTips = false
      }
      this.preScrollHeight = messageListNode.scrollHeight
    },
    onImageLoaded () {
      this.keepMessageListOnButtom()
    }
  }
}
</script>

<style lang="less" scoped>
.chat-body {
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 0 .2rem;
  .more {
    display: flex;
    justify-content: center;
    font-size: 12px;
    padding: 10px 10px;
  }
  .no-more {
    display: flex;
    justify-content: center;
    color: gray;
    font-size: 12px;
    padding: 10px 10px;
  }
}
</style>
